import React from "react";
import "./Hotel_Documents_buckets.css"
import Dashboard_buckets_card from "../../../../../common_components/dashboard_buckets_card/Dashboard_buckets_card";

function Hotel_Documents_buckets() {
  // Data Array
  const bucketData = [
    {
      imgSrc: "/assets/images/icon/open_file.webp",
      number: "25",
      heading_text: "Total Cities",
      text: "Active cities worldwide"
    },
    {
      imgSrc: "/assets/images/icon/pen_pepper.webp",
      number: "12",
      heading_text: "Active Users",
      text: "Active user accounts"
    },
    {
      imgSrc: "/assets/images/portal/global_map/buckets/hand_home.webp",
      number: "€800",
      heading_text: "Partner Properties",
      text: "Hotels and properties onboarded"
    },

       {
      imgSrc: "/assets/images/icon/verified.webp",
      number: "€800",
      heading_text: "Partner Properties",
      text: "Hotels and properties onboarded"
    },
   
  ];

  return (
    <>
      <section className="Dashboard_buckets Hotel_Documents_buckets">
        <div className="heading_text_holder">
          <h2>Documents</h2>
        </div>

        <div className="row">
          {bucketData.map((item, index) => (
            <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3" key={index}>
              <Dashboard_buckets_card
                imgSrc={item.imgSrc}
                number={item.number}
                heading_text={item.heading_text}
                text={item.text}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Hotel_Documents_buckets;
